// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotificationContent_wrapper__1fRYX","titleWrapper":"NotificationContent_titleWrapper__2Hgqa","title":"NotificationContent_title__1dtkk"};